import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {Profile} from "crqlar-react-common/dist/models/profile/profile.model";
import {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import AdditionalProperties from "crqlar-react-common/dist/components/AdditionalProperties";
import Property from "crqlar-react-common/dist/components/Property";
import {Stack} from "@mui/material";

interface Props {
    data: UseEntityData<Profile>
}

const ContactPersons = (props: Props) => {

    const {t} = useTranslation()
    const profile = props.data.item
    const setProfile = props.data.setItem
    const updateField = (field: keyof Profile, value: any) => {
        setProfile({...profile, [field]: value})
    }

    const fieldGroupGap = {xs: 3, sm: 2.5}

    return (
        <AdditionalProperties title={t('Contact persons')} variant={'outlined'} defaultExpanded={!!profile.contactPersons?.length}>
            <Stack gap={fieldGroupGap}>
            {
                profile.contactPersons?.map((contactPerson, index) => {
                    const provider = contactPerson.externalInfo?.[0]?.provider
                    const disabled = !!provider
                    return (
                        <Property
                            orientation={'vertical'}
                            key={index}
                            title={t('Contact person')}
                            subtitle={provider}
                            sx={{
                                title: {
                                    mt: 2,
                                    fontWeight: 'bold'
                                }
                            }}
                        >
                            <Stack
                                gap={1}
                                width={'100%'}
                            >
                                <Property title={t('Relation')} labelAlignment={'top'}>
                                    <TextField
                                        id={`contactPerson-${index}-relation`}
                                        size={'small'}
                                        value={contactPerson.relation}
                                        onChange={(e) => {
                                            const contactPersons = [...(profile.contactPersons || [])]
                                            contactPersons[index] = {
                                                ...contactPersons[index],
                                                relation: e.target.value
                                            }
                                            updateField('contactPersons', contactPersons)
                                        }}
                                        fullWidth
                                        disabled={disabled}
                                    />
                                </Property>

                                <Property title={t('Name prefix')} labelAlignment={'top'}>
                                    <TextField
                                        id={`contactPerson-${index}-prefix`}
                                        size={'small'}
                                        value={contactPerson.namePrefix}
                                        onChange={(e) => {
                                            const contactPersons = [...(profile.contactPersons || [])]
                                            contactPersons[index] = {
                                                ...contactPersons[index],
                                                namePrefix: e.target.value
                                            }
                                            updateField('contactPersons', contactPersons)
                                        }}
                                        fullWidth
                                        disabled={disabled}
                                    />
                                </Property>

                                <Property title={t('First name')} labelAlignment={'top'}>
                                    <TextField
                                        id={`contactPerson-${index}-first`}
                                        size={'small'}
                                        value={contactPerson.firstName}
                                        onChange={(e) => {
                                            const contactPersons = [...(profile.contactPersons || [])]
                                            contactPersons[index] = {
                                                ...contactPersons[index],
                                                firstName: e.target.value
                                            }
                                            updateField('contactPersons', contactPersons)
                                        }}
                                        fullWidth
                                        disabled={disabled}
                                    />
                                </Property>

                                <Property title={t('Last name')} labelAlignment={'top'}>
                                    <TextField
                                        id={`contactPerson-${index}-last`}
                                        size={'small'}
                                        value={contactPerson.lastName}
                                        onChange={(e) => {
                                            const contactPersons = [...(profile.contactPersons || [])]
                                            contactPersons[index] = {
                                                ...contactPersons[index],
                                                lastName: e.target.value
                                            }
                                            updateField('contactPersons', contactPersons)
                                        }}
                                        fullWidth
                                        disabled={disabled}
                                    />
                                </Property>

                                {
                                    !disabled && (
                                        <Stack direction={'row'} justifyContent={'flex-end'}>
                                            <Button
                                                variant={'text'}
                                                size={'small'}
                                                color={'error'}
                                                onClick={() => {
                                                    const contactPersons = [...(profile.contactPersons || [])]
                                                    contactPersons.splice(index, 1)
                                                    updateField('contactPersons', contactPersons)
                                                }}
                                            >
                                                {t('Delete')}
                                            </Button>
                                        </Stack>
                                    )
                                }
                            </Stack>

                        </Property>
                    )
                })
            }


            <Button
                startIcon={<AddIcon/>}
                onClick={() => {
                    const contactPersons = [...(profile.contactPersons || [])]
                    contactPersons.push({})
                    updateField('contactPersons', contactPersons)
                }}
                sx={{
                    alignSelf: 'flex-start'
                }}
            >
                {t('Add contact person')}
            </Button>

            </Stack>
        </AdditionalProperties>
    )
}

export default ContactPersons;
